export default __webpack_public_path__ + "static/media/limestone_256x256.f8a1c08a.png";